import DateUtil from "@/util/DateUtil.js";

const list = {
  components() {
    return [
      {
        component: "search-year",
        label: "",
        value: "year",
        query: { y: "year" },
        options: {
          default: new Date().getFullYear(),
          afterFix: "년",
        },
      },
      {
        component: "search-month",
        label: "월",
        value: "month",
        query: { y_m: "month" },
        options: {
          default: '',
          lastLabel: true,
          useAll: true,
        },
      },
      {
        component: "search-select-field",
        label: "사업장",
        value: "field",
        query: { f_id: "fieldId", f_name: "fieldName" },
        options: {
          default: { fieldId: "", fieldName: "" },
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["사업장명", "연도", "월", "결과서 첨부"] },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    if (search.year) {
      conditions.push({ key: "header.year", operator: "=", value: search.year });
    }

    if (search.month) {
      conditions.push({ key: "header.month", operator: "=", value: search.month });
    }

    // 사업장
    if (search.field) {
      conditions.push({ key: "body.stdInfo.field_id", operator: "=", value: search.field.fieldId });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  getHead: () => {
    return [
      {
        name: "연도",
        key: "header.year",
      },
      {
        name: "월",
        key: "header.month",
      },
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "업체명",
        key: "body.subInfo.논의심의의결내용",
      },
      {
        name: "대행기관(안전)",
        key: "body.subInfo.종사자의견",
      },
      {
        name: "대행기관(보건)",
        key: "body.stdInfo.department",
      },
      {
        name: "결과서 첨부",
        key: "body.stdInfo.section",
      },
      {
        name: "DKS 조치 대상",
        key: "body.stdInfo.writer_name",
        style: { minWidth: "120px" },
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      const postContent = JSON.parse(value.post_content);
      switch (index) {
        case 0:
          return postContent.header.year; // 연도
        case 1:
          return postContent.header.month; // 월
        case 2:
          return func.getContent(value).stdInfo.field_name; // 사업장명
        case 3:
          return func.getContent(value).subInfo.업체명; // 업체명
        case 4:
          return func.getContent(value).subInfo.기술지도기관안전; // 대행기관(안전)
        case 5:
          return func.getContent(value).subInfo.기술지도기관보건; // 대행기관(보건)
        case 6:
          // 결과서 첨부
          const file = func.getContent(value).subInfo.결과서첨부;
          return {
            type: "docsIcon",
            file: file ? { ...file } : {},
          };
        case 7:
          return func.getContent(value).DKS; // DKS 조치 대상
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
